import { createTypedOutlet } from "src/router";

import type { ForwardingDestination, WarehouseDestination } from "./types";

export type EventDestinationOutletContext =
  | {
      type: "forwarding";
      destination: ForwardingDestination;
    }
  | {
      type: "warehouse";
      destination: WarehouseDestination;
    };

const {
  OutletProvider: EventDestinationOutlet,
  useContext: useEventDestinationOutletContext,
  useOptionalContext: useEventDestinationOutletContextIfAvailable,
} = createTypedOutlet<EventDestinationOutletContext>("EventDestination");

export {
  EventDestinationOutlet,
  useEventDestinationOutletContext,
  useEventDestinationOutletContextIfAvailable,
};
